/**
 * useDeliverNeedsPhoto — bấm "Đã trả ảnh cho khách" có phải chụp ảnh bàn giao
 * trước không. Đã có ảnh bàn giao, hoặc khách đã ký nghiệm thu (máy chủ miễn
 * ảnh — QĐ 0107) ⇒ không. Dùng chung cho DeliverButton và lời nhắc của khối
 * Lịch ê-kíp, để hai nơi giữ ĐÚNG MỘT luật.
 */
import { useQuery } from "@tanstack/react-query";

import { listOrderPhotos, photoKeys } from "@/features/photo-select/api";
import { useOrderProofs } from "./api";
import { proofsOfKind } from "./utils";

export function useDeliverNeedsPhoto(orderId: string): boolean {
  const { data: proofs = [] } = useOrderProofs(orderId);
  const { data: photoView } = useQuery({
    queryKey: photoKeys.orderPhotosPage(orderId, 0, 1),
    queryFn: () => listOrderPhotos(orderId, { offset: 0, limit: 1 }),
    staleTime: 15_000,
  });
  return photoView?.session?.status !== "accepted" && proofsOfKind(proofs, "delivery").length === 0;
}
